import { Component, OnInit, ViewChild } from '@angular/core';
import { SimpleModalComponent } from '@looorent/ngx-simple-modal';
import { ApiServiceBase } from 'src/app/Services/api.service.base';
import { ToastrService } from 'ngx-toastr';
import { ModalSaveButtonComponent } from 'src/app/shared/forms/buttons/modal-save-button/modal-save-button.component';

@Component({
    selector: 'app-citationpaymentrefund',
    templateUrl: './citationpaymentrefund.component.html',
    styleUrls: ['./citationpaymentrefund.component.scss'],
    standalone: false
})
export class CitationpaymentrefundComponent extends SimpleModalComponent<any, any> implements OnInit {
  public CitationId!: number;
  public Payment: any;

  public PaidAmount: number = 0;
  public RefundedAmount: number = 0;
  public Reason: string = '';
  public Notes: string = '';

  @ViewChild(ModalSaveButtonComponent) modalSaveButton!: ModalSaveButtonComponent;

  constructor(private apiService: ApiServiceBase, private toast: ToastrService) {
    super();
  }

  ngOnInit(): void {
    const max = Math.abs(this.Payment?.AmountPaid ?? 0);
    this.PaidAmount = max;
    this.RefundedAmount = max;
  }

  UpdateValue(value: any) {
    const n = typeof value === 'number' ? value : parseFloat(`${value}`);
    if(!isFinite(n) || isNaN(n)) {
      this.RefundedAmount = 0;
      return;
    }

    if(n <= 0) {
      this.RefundedAmount = 0;
      return;
    }

    this.RefundedAmount = Math.min(n, this.PaidAmount);
  }

  confirm() {
    if(!this.CitationId) {
      this.toast.error("Citation not loaded", "Submission error");
      this.modalSaveButton.StopAnimations();
      return;
    }

    if(!this.Payment?.Id) {
      this.toast.error("Payment not loaded", "Submission error");
      this.modalSaveButton.StopAnimations();
      return;
    }

    if(!this.Reason || !this.Reason.trim()) {
      this.toast.error("Refund reason is required", "Submission error");
      this.modalSaveButton.StopAnimations();
      return;
    }

    if(!isFinite(this.RefundedAmount) || isNaN(this.RefundedAmount) || this.RefundedAmount <= 0) {
      this.toast.error("Refund amount must be greater than zero", "Submission error");
      this.modalSaveButton.StopAnimations();
      return;
    }

    if(this.RefundedAmount > this.PaidAmount) {
      this.RefundedAmount = this.PaidAmount;
    }

    this.apiService.Post(`enforcement/citations/${this.CitationId}/payments/refunds`, {
      CitationPaymentId: this.Payment.Id,
      Amount: this.RefundedAmount,
      Reason: this.Reason,
      Notes: this.Notes || null
    }).then(x => {
      this.result = x;
      this.close();
    }).catch((err) => {
      const apiMsg =
        err?.error?.Error?.Message ||
        err?.error?.Error?.message ||
        err?.error?.error ||
        err?.message;
      this.toast.error(apiMsg || "Failed to record refund.", "Submission error");
      this.modalSaveButton.StopAnimations();
    });
  }
}

